// extracted by mini-css-extract-plugin
module.exports = {"container":"container_container__15xk9","title":"container_title__1ZwJK"};